<h2 class="title">{{ title }}</h2>

<div class="results-category">
  <div class="carousel-section" *ngIf="hasPredispositions">
    <app-carousel [items]="differentRisks" [itemsPerView]="2">
      <ng-template let-request let-isLastSlide="isLastSlide">
        <div
          class="result-card"
          role="button"
          tabindex="0"
          (click)="goToRisk(request.identifier.value)"
          (keydown.enter)="goToRisk(request.identifier.value)"
          (keydown.space)="goToRisk(request.identifier.value)"
        >
          <!-- Test Info -->
          <div class="result-info">
            <h3 class="result-title">{{ request.title }}</h3>
          </div>
        </div>

        <div *ngIf="isLastSlide" class="result-card result-card--more" routerLink="/risks">
          <div class="more-risks-content">
            <h3 class="result-title">{{ "page.landing.main.button" | translate }} →</h3>
          </div>
        </div>
      </ng-template>
    </app-carousel>
  </div>

  <ng-container *ngIf="!hasPredispositions">
    <div class="results-grid">
      <div
        class="result-card"
        *ngFor="let request of dataSource.connect() | async"
        role="button"
        tabindex="0"
        (click)="goToRisk(request.identifier.value)"
        (keydown.enter)="goToRisk(request.identifier.value)"
        (keydown.space)="goToRisk(request.identifier.value)"
      >
        <!-- Test Info -->
        <div class="result-info">
          <h3 class="result-title">{{ request.title }}</h3>
          <div class="result-meta">
            <div class="result-meta-item">
              <span class="result-meta-label">{{ request.description }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="result-card result-card--more" routerLink="/risks">
        <div class="more-risks-content">
          <h3 class="result-title">{{ "page.landing.main.button" | translate }} →</h3>
        </div>
      </div>
    </div>

    <mat-paginator
      [hidden]="(dataSource.loading$ | async) || differentRisks.length === totalCount"
      (page)="onPage($event)"
      [length]="totalCount"
      [pageSize]="filters.pageSize ?? 10"
      [pageSizeOptions]="pageSizeOptions"
      [pageIndex]="(filters.page ?? 1) - 1"
      [showFirstLastButtons]="true"
      class="paginator"
      aria-label="Select page"
    ></mat-paginator>
  </ng-container>
</div>
